var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"st-ives-questionnaire"},[_c('TitleText',{attrs:{"smallTitle":true,"title":"St Ives engagement has been closed."}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }